import {
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  Box,
} from "@mui/material";
import { Alert } from "@mui/material";

function SubDomainNotExists() {
  return (
    <Container component="main" maxWidth="xs">
      <Grid
        container
        spacing={3}
        justifyContent="center"
        alignItems="center"
        style={{ minHeight: "100vh" }}
      >
        <Grid size={{ xs: 12 }}>
          <Card variant="outlined">
            <CardContent>
              <Box textAlign="center">
                <Alert severity="error">
                  The requested subdomain does not exist.
                </Alert>
                <Typography
                  variant="h5"
                  component="h2"
                  className="my-4 text-center"
                >
                  Subdomain Not Found
                </Typography>
                <Typography variant="body1" color="textSecondary">
                  We're sorry, but it seems like the subdomain you're looking
                  for doesn't exist. Please check the URL or contact support for
                  assistance.
                </Typography>
                <Box marginTop={3}>
                  <Button
                    variant="outlined"
                    color="primary"
                    href="mailto:support@example.com"
                    className="mt-4"
                    fullWidth
                  >
                    Contact Support
                  </Button>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}

export default SubDomainNotExists;
